import React from 'react';
import { connect } from 'react-redux';

// Mirrors legacy DeviceCardController.setDeviceData() action assignment
const getDeviceAction = (deviceType, id) => {
  switch (deviceType) {
    case 'video':
      return { url: `https://xfinity.com/support/repair/tv/${id}`, text: 'Troubleshoot', target: '_blank' };
    case 'internet':
    case 'voice':
      return { url: 'https://www.xfinity.com/support/repair/internet', text: 'Restart Modem', target: '_blank' };
    case 'storeFront':
      return { url: 'https://www.xfinity.com/support/repair/flex', text: 'Troubleshoot', target: '_blank' };
    case 'home':
      return { url: 'https://www.xfinity.com/support/xfinity-home/', text: 'Troubleshoot', target: '_blank' };
    default:
      return null;
  }
};

export const DeviceCardBase = ({ device, canTroubleshoot }) => {
  const {
    title, friendlyName, make, model, serialNumber,
    images, deviceType, itgLink, action: explicitAction, cardStatus, usage, id,
  } = device;

  const action = explicitAction || getDeviceAction(deviceType, id);
  const imageSrc = images && (
    images.webImageLarge || images.x2ImageLarge || images.mobileImageLarge
  );

  const cardClass = `card card--entity card--entity-devices${cardStatus ? ` ${cardStatus.cardStatusClass}` : ''}`;

  return (
    <div className="card-group mb0">
      <div className="card-group__item">
        <div className={cardClass}>
          <div className="card__content">
            {imageSrc && (
              <div className="card__image">
                <img src={imageSrc} alt={`${make} ${model}`} />
              </div>
            )}

            <div className="hgroup mb6">
              <h3 className="body1">{title}</h3>
              <p className="color--cool-grey8">
                {deviceType === 'video' && friendlyName && (
                  <span className="text-overflow text-overflow--with-quotes">
                    <span className="text-overflow__target">{friendlyName}</span>
                  </span>
                )}
                {deviceType !== 'video' && deviceType !== 'storeFront' && (
                  <span className="text-overflow">
                    <span className="text-overflow__target">
                      {make}
                      {' '}
                      {model}
                    </span>
                  </span>
                )}
                <span className="text-overflow">
                  <span className="text-overflow__target">
                    Serial #:
                    {' '}
                    {serialNumber}
                  </span>
                </span>
              </p>
              {usage && (
              <div>
                Used:
                {usage}
              </div>
              )}
            </div>

            {(!cardStatus || cardStatus.type !== 'alert') && canTroubleshoot && (
              <div className="card__action">
                {action ? (
                  <a href={action.url} target={action.target}>
                    {action.text}
                    <span className="visuallyhidden">
                      {' '}
                      {title}
                    </span>
                  </a>
                ) : itgLink && (
                  <a href={itgLink} target="_blank" rel="noopener noreferrer">
                    Troubleshoot
                    <span className="visuallyhidden">
                      {' '}
                      {title}
                    </span>
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {cardStatus && cardStatus.type === 'alert' && (
        <div className="card-group__item">
          <div className={`card ${cardStatus.cardClass || 'card--warning'}`}>
            <div className="card__content">
              <p className="mb0">{cardStatus.cardText}</p>
              {cardStatus.linkHref && (
                <a href={cardStatus.linkHref}>{cardStatus.linkText}</a>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ auth: { accountPerms = [] } = {} }) => {
  const canTroubleshoot = accountPerms.some(role => (
    role === 'PRIMARY' || role === 'BILLPAY' || role === 'UNRESTRICTED_SECONDARY'
  ));

  return { canTroubleshoot };
};

export default connect(mapStateToProps)(DeviceCardBase);
